import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-validation-guide',
  templateUrl: './validation.guide.component.html',
  styleUrls: ['./validation.guide.component.scss'],
})
export class ValidationGuideComponent {
  @Input() invalidQuestions: any[];
  @Output() questionClick = new EventEmitter<number>();

  open = false;

  toggle() {
    this.open = !this.open;
  }

  goTo(questionId: number) {
    this.questionClick.emit(questionId);
  }
}
